import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Star: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <g id="Layer_1">
      <path
        d="M23.732 34.634c-.78.087-1.387.867-1.387 1.647v4.68c0 1.126 1.04 1.906 2.167 1.559.693-.26 1.126-.867 1.126-1.56v-4.766c0-.953-.866-1.733-1.906-1.56zM42.364 26.488l-4.42-1.473c-.78-.26-1.647.087-1.993.78-.434.953 0 1.993.953 2.253l4.506 1.473c1.04.347 2.08-.433 2.08-1.56 0-.693-.433-1.3-1.126-1.473zM33.698 6.037 30.925 9.85c-.434.693-.434 1.56.086 2.166.694.693 1.907.607 2.427-.173L36.21 8.03c.606-.867.26-2.167-.78-2.513-.52-.26-1.3-.087-1.733.52zM11.686 6.037c-.433.606-.433 1.3 0 1.906l2.773 3.813c.434.693 1.387.953 2.08.607.953-.434 1.127-1.647.607-2.427l-2.773-3.813c-.78-.953-2.08-.953-2.687-.087zM10.04 25.015l-4.42 1.473c-1.04.347-1.473 1.647-.78 2.513.434.52 1.127.78 1.82.607l4.506-1.473c.954-.26 1.387-1.387.954-2.254s-1.3-1.126-2.08-.866z"
        style={{
          fill: '#002677',
        }}
      />
      <path
        d="m23.975 29.54-9.17 6.374c-.447.336-1.118-.111-1.006-.67l3.243-10.624-8.835-6.71c-.447-.336-.223-1.118.336-1.118l11.183-.224 3.731-10.802a.548.548 0 0 1 1.036 0l3.732 10.802 11.183.224c.559 0 .894.782.335 1.118l-8.834 6.71 3.243 10.623c.223.56-.448 1.007-1.007.671l-9.17-6.374z"
        style={{
          fill: '#ff612b',
        }}
      />
    </g>
  </Box>
)
export default Star
